import {
  GET_SERVICE_TYPE,
  GET_SERVICE_TYPE_FAIL,
  GET_SERVICE_TYPE_SUCCESS,
  GET_SERVICE_TYPES,
  GET_SERVICE_TYPES_FAIL,
  GET_SERVICE_TYPES_SUCCESS,
  ADD_NEW_SERVICE_TYPE,
  ADD_SERVICE_TYPE_SUCCESS,
  ADD_SERVICE_TYPE_FAIL,
  UPDATE_SERVICE_TYPE,
  UPDATE_SERVICE_TYPE_SUCCESS,
  UPDATE_SERVICE_TYPE_FAIL,
  DELETE_SERVICE_TYPE,
  DELETE_SERVICE_TYPE_SUCCESS,
  DELETE_SERVICE_TYPE_FAIL,
  SET_STATE_SERVICE_TYPE,
  UPDATE_SERVICE_TYPE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_SERVICE_TYPE,
  payload: loading,
})

export const getServiceTypes = ( params ) => ({
  type: GET_SERVICE_TYPES,
  payload: { params },
})

export const getServiceTypesSuccess = (serviceTypes,totalPages, currentPage) => ({
  type: GET_SERVICE_TYPES_SUCCESS,
  payload: {serviceTypes:serviceTypes, total:totalPages, currentPage:currentPage}
})

export const getServiceTypesFail = error => ({
  type: GET_SERVICE_TYPES_FAIL,
  payload: error,
})

export const addNewServiceType = serviceType => ({
  type: ADD_NEW_SERVICE_TYPE,
  payload: serviceType,
})

export const addServiceTypeSuccess = serviceType => ({
  type: ADD_SERVICE_TYPE_SUCCESS,
  payload: serviceType,
})  

export const addServiceTypeFail = error => ({
  type: ADD_SERVICE_TYPE_FAIL,
  payload: error,
})

export const updateServiceType = serviceType => ({
  type: UPDATE_SERVICE_TYPE,
  payload: serviceType,
})

export const updateServiceTypeStatus = serviceType => ({
  type: UPDATE_SERVICE_TYPE_STATUS,
  payload: serviceType,
})

export const updateServiceTypeSuccess = serviceType => ({
  type: UPDATE_SERVICE_TYPE_SUCCESS,
  payload: serviceType,
})

export const updateServiceTypeFail = error => ({
  type: UPDATE_SERVICE_TYPE_FAIL,
  payload: error,
})

export const deleteServiceType = serviceType => ({
  type: DELETE_SERVICE_TYPE,
  payload: serviceType,
})

export const deleteServiceTypeSuccess = id => ({
  type: DELETE_SERVICE_TYPE_SUCCESS,
  id,
})

export const deleteServiceTypeFail = error => ({
  type: DELETE_SERVICE_TYPE_FAIL,
  payload: error,
})

export const getServiceType = () => ({
  type: GET_SERVICE_TYPE,
})

export const getServiceTypeSuccess = serviceType => ({
  type: GET_SERVICE_TYPE_SUCCESS,
  payload: serviceType,
})

export const getServiceTypeFail = error => ({
  type: GET_SERVICE_TYPE_FAIL,
  payload: error,
})
